module.exports = __webpack_public_path__ + "img/kites-cover-image.7c4945bd.png";